import { render, staticRenderFns } from "./sysDictionaryDetail.vue?vue&type=template&id=f195ca42&"
import script from "./sysDictionaryDetail.vue?vue&type=script&lang=js&"
export * from "./sysDictionaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f195ca42')) {
      api.createRecord('f195ca42', component.options)
    } else {
      api.reload('f195ca42', component.options)
    }
    module.hot.accept("./sysDictionaryDetail.vue?vue&type=template&id=f195ca42&", function () {
      api.rerender('f195ca42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/systemTools/dictionary/sysDictionaryDetail.vue"
export default component.exports